import React, { useState, useEffect } from 'react'

import { Button, Card, Table, Typography, Input, Icon } from 'antd'

import { CustomBreadcrumb } from '../../components/CustomBreadcrumb/CustomBreadcrumb'
import { TableLineDisable } from '../../components/TableLineDisable/TableLineDisable'
import { validRule, RULES } from '../../constants/Entitlements'
import { api, request } from '../../util/handlerRequestUtil'
import { getMessage } from '../../util/IntlMessages'

const ListPermissions = function ({ match, history }) {
  const [formatedData, setFormatedData] = useState([])
  const { count, page, pageSize } = formatedData

  // Created component
  useEffect(() => {
    const hasAccess = validRule(RULES.PROFILE) // Não deixa acessar a tela
    if (!hasAccess) {
      return history.push('/home')
    }

    listData()
  }, [])

  async function listData(params) {
    try {
      const response = await request(api.listProfiles(params))

      const { items } = response

      const formatedRows = []

      items.map((item) => {
        return formatedRows.push({
          key: item.id,
          ...item,
          data: formatDataContent(item.id)
        })
      })

      setFormatedData({
        ...response.data,
        items: formatedRows
      })
    } catch (error) {
      console.tron.log('error', error)
    }
  }

  function sortText(a, b, field) {
    if (a !== null && a[field] !== null && b !== null && b[field] !== null && field !== null) {
      if (a[field] < b[field]) return -1
      if (a[field] > b[field]) return 1
    }

    return 0
  }

  const columns = [
    {
      title: getMessage('description'),
      dataIndex: 'profileName',
      width: '90%',
      sorter: (a, b) => sortText(a, b, 'profileName'),
      render: (item, line) => <TableLineDisable item={item} line={line} />
    },
    {
      title: getMessage('edit'),
      dataIndex: 'data',
      width: '10%'
    }
  ]

  function onChange(pagination) {
    const { current } = pagination
    listData({ page: current - 1 })
  }

  const formatDataContent = (id) => (
    <Button
      className="default-actionContent-button"
      type="link"
      onClick={() => {
        history.push(`/permissions/${id}`)
      }}
    >
      <Icon type="edit" className="default-actionContent-icon" />
    </Button>
  )

  function renderHeader() {
    return (
      <div className="default-header-div">
        <Typography.Title className="default-header-title" level={3}>
          {getMessage('listPermissions')}
        </Typography.Title>
        <div className="default-header-breadcrumb">
          <CustomBreadcrumb match={match} history={history} />
        </div>
      </div>
    )
  }

  function getColumns() {
    const hasAccess = validRule(RULES.PROFILE) // Remove o lapis da lista
    if (hasAccess) {
      return columns
    }

    if (columns !== null) {
      columns.pop()
      return columns
    }
  }

  return (
    <>
      {renderHeader()}

      <Card className="ant-card gx-card ant-card-bordered">
        <Input.Search
          className="default-header-search"
          onSearch={(value) => listData({ search: value })}
          placeholder={getMessage('search')}
        />
        <Table
          key="id"
          columns={getColumns()}
          dataSource={formatedData.items}
          onChange={onChange}
          pagination={{ pageSize, current: page + 1, total: count }}
        />
      </Card>
    </>
  )
}

export default ListPermissions
